
import { Pane } from 'evergreen-ui'
const StatusRegister_1 = ({ DataRegister }) => {
  console.log(DataRegister[0])
  const validCodes = [
    "1101",
    "1102",
    "1103",
    "1106",
    "1110",
    "1207",
    "1208",
    "1301",
    "1302",
    "1304",
    "1310",
  ];
  return (
    <>

      {
        (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
          (
            <>
              {
                (DataRegister[0].ROB_ID === "183" || DataRegister[0].ROB_ID === "184") ?
                  validCodes.includes(DataRegister[0].Major1_MAJOR_ID) ?
                    (
                      <>
                        <Pane
                          color="#fff"
                          backgroundColor="#008616ff"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={14}
                          fontFamily=""
                          margin={0}
                          fontWeight={700}
                          justifyContent="center"
                          alignItems="center"
                          display="flex"
                          flexDirection="column"
                        >
                          มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                          {/* รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 27 มีนาคม 2569 */}
                        </Pane>
                      </>
                    )
                    :
                    (

                      <Pane
                        color="#fff"
                        backgroundColor="#008616ff"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={14}
                        fontFamily=""
                        margin={0}
                        fontWeight={700}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                      >
                        รอประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 9 เมษายน 2569
                      </Pane>


                    )
                  :
                  (
                    <>
                      {
                        (DataRegister[0].ROB_ID === "186" || DataRegister[0].ROB_ID === "179" || DataRegister[0].ROB_ID === "182") ? (
                          <Pane
                            color="#fff"
                            backgroundColor="#008616ff"
                            height="100%"
                            paddingY={4}
                            paddingX={5}
                            fontSize={14}
                            fontFamily=""
                            margin={0}
                            fontWeight={700}
                            justifyContent="center"
                            alignItems="center"
                            display="flex"
                            flexDirection="column"
                          >
                            มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                            {/* ชำระค่าสมัครแล้ว
                            รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 27 มีนาคม 2569 */}
                          </Pane>
                        ) : (
                          <></>
                        )
                      }

                    </>
                  )
              }

            </>

          ) :
          (


            (DataRegister[0].REGISTER_TYPE_ID !== "1" || DataRegister[0].REGISTER_TYPE_ID !== "5") ?
              (
                <>
                  {/* <Pane
                    color="#fff"
                    backgroundColor="#008616ff"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    fontWeight={700}
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >

                    ชำระค่าสมัครแล้ว
                    รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                  </Pane> */}
                  <Pane
                          color="#fff"
                          backgroundColor="#008616ff"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={14}
                          fontFamily=""
                          margin={0}
                          fontWeight={700}
                          justifyContent="center"
                          alignItems="center"
                          display="flex"
                          flexDirection="column"
                        >
                          มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                          {/* รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 27 มีนาคม 2569 */}
                        </Pane>
                </>
              ) : (
                <>
                  <Pane
                    color="#fff"
                    backgroundColor="#008616ff"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    fontWeight={700}
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    {/* ชำระค่าสมัครแล้ว
            รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                  </Pane>
                </>
              )

          )
      }


    </>

  )
}

export default StatusRegister_1